import React, { useEffect, useState } from "react";
import { Table, Button, message } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import api from "../api";
import CreateTipoCajaModal from "../components/CreateTipoCajaModal";

const TiposCajasPage = () => {
  const [tiposCajas, setTiposCajas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);

  const getTiposCajas = async () => {
    try {
      setLoading(true);
      const res = await api.get("/tiposCajas/obtener");
      setTiposCajas(res.data);
    } catch (err) {
      message.error("Error al obtener tipos de cajas");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getTiposCajas();
  }, []);

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 16,
          flexWrap: "wrap",
          gap: "16px",
        }}
      >
        <h2 style={{ fontSize: 20, fontWeight: 600, margin: 0 }}>Tipos de Cajas</h2>
        <Button type="primary" icon={<PlusOutlined />} onClick={() => setOpen(true)}>
          Nuevo Tipo de Caja
        </Button>
      </div>

      <Table
        dataSource={tiposCajas}
        loading={loading}
        rowKey="nombre"
        columns={[
          { title: "Nombre", dataIndex: "nombre" },
          { title: "Peso (Kg)", dataIndex: "pesoKg" },
        ]}
        scroll={{ x: 'max-content' }}
      />

      <CreateTipoCajaModal
        open={open}
        onCancel={() => setOpen(false)}
        onSuccess={() => {
          setOpen(false);
          getTiposCajas();
        }}
      />
    </>
  );
};

export default TiposCajasPage;
